/**
 * SVGs por variant para DocCard.
 *
 * Sprint 11 v2 S11-V2-09. Refactor Sprint 12 S12-09: el tipo
 * `DocumentoIconVariant` vive aqui (antes en mocks-dashboard, ahora
 * eliminado tras consumir backend real).
 */
import type { JSX } from 'react';

export type DocumentoIconVariant = 'danger' | 'info' | 'neutral' | 'success';

export const DOC_ICONS_BY_VARIANT: Record<DocumentoIconVariant, JSX.Element> = {
  danger: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      aria-hidden="true"
    >
      <path d="M12 2 L4 6 V12 C4 17 7.5 21 12 22 C16.5 21 20 17 20 12 V6 Z" />
    </svg>
  ),
  info: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      aria-hidden="true"
    >
      <rect x="4" y="3" width="16" height="18" />
      <line x1="8" y1="8" x2="16" y2="8" />
      <line x1="8" y1="12" x2="16" y2="12" />
      <line x1="8" y1="16" x2="12" y2="16" />
    </svg>
  ),
  neutral: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      aria-hidden="true"
    >
      <rect x="3" y="3" width="18" height="18" />
      <line x1="9" y1="3" x2="9" y2="21" />
      <line x1="15" y1="3" x2="15" y2="21" />
    </svg>
  ),
  success: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      aria-hidden="true"
    >
      <path d="M12 2 V22" />
      <path d="M17 6 C17 4 15 3 12 3 C9 3 7 4 7 6 C7 8 9 9 12 9 C15 9 17 10 17 12 C17 14 15 15 12 15 C9 15 7 14 7 12" />
    </svg>
  ),
};
